import KAMPYLE_CONSTANT from "./KAMPYLE_CONSTANT";
import KAMPYLE_DATA from "./KAMPYLE_DATA";
import KAMPYLE_EVENT_DISPATCHER from "./KAMPYLE_EVENT_DISPATCHER";
import KAMPYLE_FUNC from "./KAMPYLE_FUNC";

  function init() {
    var eventMapping = {
      neb_formLoadingHasFailed: [onFormLoadingFailed],
      neb_formClosed: [onFormClosed],
      ...(KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.TARGETING_EVENTS_REPORTING)) && 
      {MDigital_targetingRuleEvaluated: [updateTargetingState]}
    };
    KAMPYLE_EVENT_DISPATCHER.subscribeMany(eventMapping);
  }

  function onFormClosed(eventName, data) {
    var formId = data.formId;
    if (formId) {
      // old V1 forms (without this fix https://github.medallia.com/Digital/kampyleappv5/pull/5048)
      // doesn't send formId on "formClose" event
      KAMPYLE_DATA.setFormState(data.formId, { shown: false });
    }
  }

  function onFormLoadingFailed(eventName, data) {
    var failureState = {};
    failureState[data.failureCause] = true;
    KAMPYLE_DATA.setFormState(data.formId, failureState);
  }

  function updateTargetingState(eventName, data){
    if(!canUpdateState(data)){return false;}

    var formState = KAMPYLE_DATA.getFormState(data.formId);
    var phaseRules = [].concat(formState.targeting[data.targetingPhase] || []);
    phaseRules.push(getRuleData(data));

    var targetingPhaseState = {};
    targetingPhaseState[data.targetingPhase] = phaseRules;

    KAMPYLE_DATA.setFormState(data.formId, {targeting : targetingPhaseState});
  }

  function isInviteLoaded(formId){
    var formState = KAMPYLE_DATA.getFormState(formId);
    return !!formState && !!formState.inviteLoaded;
  }

  function isFormLoaded(formId){
    var formState = KAMPYLE_DATA.getFormState(formId);
    return !!formState && !!formState.loaded
  }

  function isFormFullyLoaded(formId) {
    var isSeparate = KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.FORM_TEMPLATE_DATA_SEPERATION) 
    var formState = KAMPYLE_DATA.getFormState(formId);
    if(!isSeparate) {
      return formState.loaded
    }
    return formState.loaded && KAMPYLE_FUNC.isJsonDataLoaded(formId, false)
  }

  function shouldFormBeShown(formId){
    var formState = KAMPYLE_DATA.getFormState(formId);
    return formState && formState.shouldBeShown;
  }
  
  function isFormShown(formId){
    var formState = KAMPYLE_DATA.getFormState(formId);
    return formState && formState.shown;
  }

  function getRuleData(data){
    var ruleData = {
      targetingRule : "",
      isPassed : false,
      expected : "",
      actual : "",
    };

    Object.keys(ruleData).forEach(function(property) {
      ruleData[property] = data[property];
    });

    return ruleData;
  }

  function canUpdateState(data){
    data = data || {};

    var formState = KAMPYLE_DATA.getFormState(data.formId);
    return !(!formState || !formState.targeting || !data.targetingPhase);

  }

  export default {
    //Public API
    init: init,
    updateTargetingState: updateTargetingState,
    getRuleData: getRuleData,
    canUpdateState: canUpdateState,
    shouldFormBeShown: shouldFormBeShown,
    isFormLoaded:isFormLoaded,
    isInviteLoaded:isInviteLoaded,
    isFormShown:isFormShown,
    isFormFullyLoaded:isFormFullyLoaded,
  };